// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.team-logo-img {
  height: 32px; /* Height of the logo */
  width: 32px; /* Width of the logo */
  position: relative;
  overflow: hidden;
  flex-shrink: 0;
  object-fit: contain; /* Changed from cover to contain to avoid cropping */
}

.pick-stats-team-bar {
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center; /* Center items vertically */
  justify-content: center; /* Center items horizontally */
  box-sizing: border-box;
  gap: 8px;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  font-size: 12px;
  color: #002129;
  font-family: Inter;
}

.pick-stats-team-text-container {
  position: relative;
  white-space: nowrap;
  font-weight: 500;
  display: flex;
  flex-direction: column;
  justify-content: center; /* Align text vertically within its container */
}

.selected-team,
.opposing-team {
  margin: 0;
}

.status-header {
  font-weight: 500;
  color: inherit;
  text-decoration: underline;
  display: inline-block;
  min-width: 115px;
  font-size: 12px !important; /* Default font size */
}

.status-details {
  text-decoration: none;
  text-align: center;
  font-weight: 500;
  color: inherit;
  font-size: 12px !important; /* Default font size */
}

@media (min-width: 768px) {
  .status-header,
  .status-details {
    font-size: 22px !important; /* Font size for larger screens */
  }
}
.status-section {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
  min-width: 75px;
  flex: 1 1;
}

.survivor-entry-info-container {
  width: 100%;
  background-color: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 10px 20px; /* Adjusted padding */
  box-sizing: border-box;
  font-size: 12px;
  color: #002129;
  font-family: Inter;
}

.survivor-entry-info {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between; /* Adjusted to distribute space evenly */
  gap: 28px;
  width: 100%;
  max-width: 258px;
}

@media (min-width: 768px) {
  .survivor-entry-info {
    max-width: 500px; /* Max-width for screens > 768px */
  }
}
.team-logo-desktop-img {
  height: 40px;
  width: 40px;
  position: relative;
  overflow: hidden;
  flex-shrink: 0;
  object-fit: contain;
}

.selected-team-desktop {
  position: relative;
  font-weight: 500;
}

.pick-stats-team-bar-desktop,
.pick-stats-team-text-container-desktop {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  padding: 6.5px 0 0;
  white-space: nowrap;
}

.pick-stats-team-bar-desktop {
  width: 100%;
  flex-direction: row;
  padding: 20.5px 27px;
  box-sizing: border-box;
  gap: 19px;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  font-size: 22px;
  color: #1e1e1e;
  font-family: Inter;
}`, "",{"version":3,"sources":["webpack://./src/components/NFLSurvivor/NFLSurvivorStyles/SurvivorPickStats.scss"],"names":[],"mappings":"AAAA;EACI,YAAA,EAAA,uBAAA;EACA,WAAA,EAAA,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA,EAAA,oDAAA;AACJ;;AAEA;EACI,WAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA,EAAA,4BAAA;EACA,uBAAA,EAAA,8BAAA;EACA,sBAAA;EACA,QAAA;EACA,mBAAA;EACA,sBAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;EACA,kBAAA;AACJ;;AAEA;EACI,kBAAA;EACA,mBAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA,EAAA,+CAAA;AACJ;;AAEA;;EAEI,SAAA;AACJ;;AAEA;EACI,gBAAA;EACA,cAAA;EACA,0BAAA;EACA,qBAAA;EACA,gBAAA;EACA,0BAAA,EAAA,sBAAA;AACJ;;AAEA;EACI,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,0BAAA,EAAA,sBAAA;AACJ;;AAEA;EACI;;IAEI,0BAAA,EAAA,iCAAA;EACN;AACF;AAGA;EACI,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,SAAA;EACA,eAAA;EACA,SAAA;AADJ;;AAIA;EACI,WAAA;EACA,sBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA,EAAA,qBAAA;EACA,sBAAA;EACA,eAAA;EACA,cAAA;EACA,kBAAA;AADJ;;AAIA;EACI,aAAA;EACA,mBAAA;EACA,eAAA;EACA,8BAAA,EAAA,wCAAA;EACA,SAAA;EACA,WAAA;EACA,gBAAA;AADJ;;AAIA;EACI;IACI,gBAAA,EAAA,kCAAA;EADN;AACF;AAIA;EACI,YAAA;EACA,WAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;AAFJ;;AAIE;EACE,kBAAA;EACA,gBAAA;AADJ;;AAGE;;EAEE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,2BAAA;EACA,kBAAA;EACA,mBAAA;AAAJ;;AAEE;EACE,WAAA;EACA,mBAAA;EACA,oBAAA;EACA,sBAAA;EACA,SAAA;EACA,mBAAA;EACA,sBAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;EACA,kBAAA;AACJ","sourcesContent":[".team-logo-img {\n    height: 32px; /* Height of the logo */\n    width: 32px; /* Width of the logo */\n    position: relative;\n    overflow: hidden;\n    flex-shrink: 0;\n    object-fit: contain; /* Changed from cover to contain to avoid cropping */\n}\n\n.pick-stats-team-bar {\n    width: 100%;\n    display: flex;\n    flex-direction: row;\n    align-items: center; /* Center items vertically */\n    justify-content: center; /* Center items horizontally */\n    box-sizing: border-box;\n    gap: 8px;\n    line-height: normal;\n    letter-spacing: normal;\n    text-align: left;\n    font-size: 12px;\n    color: #002129;\n    font-family: Inter;\n}\n\n.pick-stats-team-text-container {\n    position: relative;\n    white-space: nowrap;\n    font-weight: 500;\n    display: flex;\n    flex-direction: column;\n    justify-content: center; /* Align text vertically within its container */\n}\n\n.selected-team,\n.opposing-team {\n    margin: 0;\n}\n\n.status-header {\n    font-weight: 500;\n    color: inherit;\n    text-decoration: underline;\n    display: inline-block;\n    min-width: 115px;\n    font-size: 12px !important; /* Default font size */\n}\n  \n.status-details {\n    text-decoration: none;\n    text-align: center;\n    font-weight: 500;\n    color: inherit;\n    font-size: 12px !important; /* Default font size */\n}\n\n@media (min-width: 768px) {\n    .status-header,\n    .status-details {\n        font-size: 22px !important; /* Font size for larger screens */\n    }\n}\n\n  \n.status-section {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    gap: 12px;\n    min-width: 75px;\n    flex: 1;\n}\n  \n.survivor-entry-info-container {\n    width: 100%;\n    background-color: #fff;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    padding: 10px 20px; /* Adjusted padding */\n    box-sizing: border-box;\n    font-size: 12px;\n    color: #002129;\n    font-family: Inter;\n}\n  \n.survivor-entry-info {\n    display: flex;\n    flex-direction: row;\n    flex-wrap: wrap;\n    justify-content: space-between; /* Adjusted to distribute space evenly */\n    gap: 28px;\n    width: 100%;\n    max-width: 258px;\n}\n\n@media (min-width: 768px) {\n    .survivor-entry-info {\n        max-width: 500px; /* Max-width for screens > 768px */\n    }\n}\n  \n.team-logo-desktop-img {\n    height: 40px;\n    width: 40px;\n    position: relative;\n    overflow: hidden;\n    flex-shrink: 0;\n    object-fit: contain;\n  }\n  .selected-team-desktop {\n    position: relative;\n    font-weight: 500;\n  }\n  .pick-stats-team-bar-desktop,\n  .pick-stats-team-text-container-desktop {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    justify-content: flex-start;\n    padding: 6.5px 0 0;\n    white-space: nowrap;\n  }\n  .pick-stats-team-bar-desktop {\n    width: 100%;\n    flex-direction: row;\n    padding: 20.5px 27px;\n    box-sizing: border-box;\n    gap: 19px;\n    line-height: normal;\n    letter-spacing: normal;\n    text-align: left;\n    font-size: 22px;\n    color: #1e1e1e;\n    font-family: Inter;\n  }\n  \n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
